import { Tooltip } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';
import GenericInfo from '@/external/icons/GenericInfo';

type Props = {
  tooltipContent: string;
};

const InfoTooltip: FC<Props> = ({ tooltipContent }) => (
  <Tooltip>
    <Tooltip.Trigger className="h-8 w-8 self-center">
      <span>
        <GenericInfo className="text-moon-32 text-trunks" />
      </span>
    </Tooltip.Trigger>
    <Tooltip.Content className="w-96 text-center">
      <Translate id={tooltipContent} />
      <Tooltip.Arrow />
    </Tooltip.Content>
  </Tooltip>
);

export default InfoTooltip;
